module.exports = __webpack_public_path__ + "assets/56bb43da5014471d43112eabfa39039b.png";